import { parse } from 'date-fns';
import { useEffect, useState } from 'react';

import { useStore } from '../core/store';

export function useBookingCountdown() {
  const { BookingStore } = useStore();
  const booking = BookingStore.booking?.data;

  const [config, setConfig] = useState({
    counter: false,
    counterDays: 0,
    counterHours: 0,
    counterMinutes: 0,
  });

  const updateTimer = () => {
    const startTime = parse(
      booking.startDate,
      'dd.MM.yyyy',
      new Date(),
    ).getTime();

    const timeLeft = startTime - Date.now();
    setConfig(updateConfig(timeLeft));
  };

  useEffect(() => {
    if (booking?.startDate) {
      updateTimer();
      const interval = setInterval(updateTimer, 1000 * 60); // update timer every minute

      return () => clearInterval(interval);
    }
  }, [booking?.startDate]);

  return config;
}

const updateConfig = (countdown) => {
  let days = Math.floor(countdown / (1000 * 60 * 60 * 24));
  let hours = Math.floor((countdown / (1000 * 60 * 60)) % 24);
  let minutes = Math.floor((countdown / (1000 * 60)) % 60);

  if (countdown < 0) {
    days = 0;
    hours = 0;
    minutes = 0;
  }

  return {
    counter: countdown > 0,
    counterDays: days,
    counterHours: hours,
    counterMinutes: minutes,
  };
};
